import React from "react";

interface JobDescSkeletonProps {
  isMobile: boolean;
}

interface ShimmerBgHeaderProps {
  isMobile: boolean;
}

const ShimmerBgHeader: React.FC<ShimmerBgHeaderProps> = ({ isMobile }) => {
  return (
    <div
      className={`relative min-h-[94px] bg-gray-200 ${isMobile ? "!-ml-4 !-mr-4 !-mt-4" : "rounded-t-2xl"}`}
    >
      <div className="absolute left-[24px] top-[44px] h-[70px] w-full rounded-[4px]"></div>
    </div>
  );
};

const ShimmerJobHeader = () => {
  return (
    <div className="flex flex-col gap-2 py-5">
      <div className="flex items-center justify-between">
        <div className="h-[26px] w-[40%] bg-gray-200"></div>
      </div>
      <div className="h-[16px] w-[70%] bg-gray-200"></div>
      <div className="flex gap-2">
        <div className="h-[28px] w-[20%] bg-gray-200"></div>
        <div className="h-[28px] w-[20%] bg-gray-200"></div>
        <div className="h-[28px] w-[20%] bg-gray-200"></div>
        <div className="h-[28px] w-[20%] bg-gray-200"></div>
        <div className="h-[28px] w-[20%] bg-gray-200"></div>
      </div>
    </div>
  );
};

const ShimmerJobHighlights = () => {
  return (
    <div className="flex flex-col gap-5 pt-2">
      <div className="flex items-center gap-2.5">
        <div className="shimmerBG h-[20px] w-[20%] bg-gray-200"></div>
        <div className="shimmerBG h-[20px] w-[15%] bg-gray-200"></div>
        <div className="shimmerBG h-[20px] w-[15%] bg-gray-200"></div>
      </div>
      <div className="shimmerBG h-[20px] w-[40%] bg-gray-200"></div>
      <div className="shimmerBG h-[20px] w-[70%] bg-gray-200"></div>
      <div className="shimmerBG h-[20px] w-[70%] bg-gray-200"></div>
    </div>
  );
};

const ShimmerApplyJob = () => {
  return (
    <div className="shimmerBG mt-[26px] h-[46px] w-[15%] bg-gray-200"></div>
  );
};

const ShimmerJobDescription = () => {
  return (
    <div className="mt-[26px] flex flex-col gap-[12px]">
      <div className="shimmerBG h-[20px] w-[10%] bg-gray-200"></div>
      <div className="shimmerBG h-[64px] w-[80%] bg-gray-200"></div>
      <div className="shimmerBG h-[118px] w-[80%] bg-gray-200"></div>
      <div className="shimmerBG h-[20px] w-[10%] bg-gray-200"></div>
      <div className="shimmerBG h-[64px] w-[100%] bg-gray-200"></div>
      <div className="shimmerBG h-[118px] w-[100%] bg-gray-200"></div>
    </div>
  );
};

const Skeleton: React.FC<JobDescSkeletonProps> = ({ isMobile }) => {
  return (
    <div className={`${isMobile ? "!h-[100vh]" : ""}`}>
      <ShimmerBgHeader isMobile={isMobile}></ShimmerBgHeader>

      <div
        className={`md:!border-border-subtle ${isMobile ? "" : "px-6"} md:!border md:!border-solid`}
      >
        <ShimmerJobHeader></ShimmerJobHeader>
        <ShimmerJobHighlights></ShimmerJobHighlights>
        <ShimmerApplyJob></ShimmerApplyJob>
        <ShimmerJobDescription></ShimmerJobDescription>
      </div>
    </div>
  );
};

export default React.memo(Skeleton);
